import React from "react";
import { View, ViewProps } from "react-native";

type Props = ViewProps & {
  children: React.ReactNode;
};

export const FormCard: React.FC<Props> = ({
  children,
  className = "",
  ...rest
}) => {
  return (
    <View
      className={`w-full max-w-md bg-white p-6 xs:p-10 xs:rounded-3xl xs:shadow-2xl overflow-hidden ${className}`}
      {...rest}
    >
      {children}
    </View>
  );
};

export default FormCard;
